// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1e92I","ranges":"BmiRanges_ranges__2xw07"};